import { Link } from "react-router-dom";
import { InstagramLogo, Globe, Phone, EnvelopeSimple } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-black mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <h3 className="font-display text-4xl sm:text-5xl leading-none">
            URBAN FEST<br /><span className="text-[#FF6B1A]">2026</span>
          </h3>
          <p className="mt-4 text-white/60 max-w-sm">
            Le tournoi inter-quartiers qui fait vibrer La Roche-sur-Yon. Basket, foot, culture urbaine.
          </p>

          <div className="flex items-center gap-3 mt-6" data-testid="footer-social">
            <a
              href="https://www.instagram.com/action.impact.jeunesse/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram Action Impact Jeunesse"
              className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:border-[#FF6B1A] hover:text-[#FF6B1A] transition-colors"
              data-testid="footer-instagram"
            >
              <InstagramLogo size={20} weight="bold" />
            </a>
            <a
              href="https://www.actionimpactjeunesse.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Site web Action Impact Jeunesse"
              className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:border-[#FF6B1A] hover:text-[#FF6B1A] transition-colors"
              data-testid="footer-website"
            >
              <Globe size={20} weight="bold" />
            </a>
            <a
              href="tel:+33695622953"
              aria-label="Téléphone"
              className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:border-[#FF6B1A] hover:text-[#FF6B1A] transition-colors"
              data-testid="footer-phone"
            >
              <Phone size={20} weight="bold" />
            </a>
            <a
              href="mailto:actionimpactjeunesse@gmail.com"
              aria-label="Email"
              className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:border-[#FF6B1A] hover:text-[#FF6B1A] transition-colors"
              data-testid="footer-email"
            >
              <EnvelopeSimple size={20} weight="bold" />
            </a>
          </div>
        </div>

        <div>
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-white/40 mb-4">Navigation</p>
          <ul className="space-y-2">
            <li><Link to="/programme" className="hover:text-[#FF6B1A]">Programme</Link></li>
            <li><Link to="/classement" className="hover:text-[#FF6B1A]">Classement</Link></li>
            <li><Link to="/galerie" className="hover:text-[#FF6B1A]">Galerie</Link></li>
            <li><Link to="/inscription" className="hover:text-[#FF6B1A]">Inscription</Link></li>
            <li><Link to="/autorisation" className="hover:text-[#FF6B1A]">Autorisation mineurs</Link></li>
            <li><Link to="/contact" className="hover:text-[#FF6B1A]">Contact</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-white/40 mb-4">Organisé par</p>
          <div className="flex items-center gap-3 mb-3">
            <img
              src="https://customer-assets.emergentagent.com/job_festurban-live/artifacts/l19s6upi_logo%20action%20impact%20jeunesse.png"
              alt="Action Impact Jeunesse"
              className="w-14 h-14 rounded-full object-cover border border-white/10"
            />
            <p className="font-bold leading-tight">Action Impact<br />Jeunesse</p>
          </div>
          <a
            href="https://www.actionimpactjeunesse.com"
            target="_blank"
            rel="noreferrer"
            className="block text-white/60 text-sm hover:text-[#FF6B1A]"
          >
            actionimpactjeunesse.com
          </a>
          <a
            href="https://www.instagram.com/action.impact.jeunesse/"
            target="_blank"
            rel="noreferrer"
            className="block text-white/60 text-sm hover:text-[#FF6B1A]"
          >
            @action.impact.jeunesse
          </a>
          <p className="text-white/60 text-sm mt-2">06 95 62 29 53</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-white/40 text-xs tracking-widest uppercase">
        © 2026 Urban Fest — La Roche-sur-Yon
      </div>
    </footer>
  );
}
